
import { mapGetters } from "vuex"
import { mdiDelete } from "@mdi/js"
import SearchWrapper from "@/components/base/input/SearchWrapper"
import ProgressLinear from "@/components/base/ProgressLinear"
const debounce = require("lodash.debounce")
import { routeToBusiness, routeToBusinessSite } from "@/helpers/routing.js"

export default {
    name: "BusinessSearch",
    components: {
        BusinessCard: () => import("@/components/business/BusinessCard"),
        BusinessLogo: () => import("@/components/business/BusinessLogo"),
        SearchWrapper,
        ProgressLinear,
    },
    props: {
        prefix: {
            type: String,
            default: "Gib z.B.",
        },
        exampleSuggestions: {
            type: Array,
            default: () => ["Sparkasse", "msg", "Malteser", "BMW", "Klinikum"],
        },
    },
    data() {
        return {
            mdiDelete,
            dialog: false,
            searchInput: "",
            searchResults: [],
            isSearchPending: false,
            debouncedSearch: debounce(this.sendRequest, 500, {
                trailing: true,
            }),
            inputBuffer: [],
        }
    },
    computed: {
        ...mapGetters("search", ["filter", "channel"]),
        inputPlaceholder() {
            if (this.$breakpoint.xsOnly) {
                return "Betrieb suchen"
            }
            return "Welchen Betrieb suchst du?"
        },
    },
    destroyed() {
        this.clearSearch()
    },
    methods: {
        onSearchChange() {
            this.inputBuffer.push(this.searchInput)
            this.isSearchPending = true
            this.debouncedSearch()
        },
        routeToBusiness(business) {
            if (business.is_site_management_enabled) {
                return routeToBusinessSite(business)
            } else {
                return routeToBusiness(business)
            }
        },

        async sendRequest() {
            if (this.searchInput.length > 0) {
                let searchParams = {
                    filters: this.filter,
                    category: "Unternehmen",
                    channel: this.channel,
                    search: this.searchInput,
                }

                const response = await this.$axios
                    .$get("/api/search/business", {
                        params: searchParams,
                    })
                    .catch((err) => console.warn(err))
                this.$oabalytics.trackEvent(`v1search_search_business`, {
                    query: this.searchInput,
                    numResults: response?.data?.length,
                    input: this.inputBuffer,
                })
                this.inputBuffer = []
                this.searchResults = response?.data ?? []
            } else {
                this.clearSearch()
            }
            this.isSearchPending = false
        },
        clearSearch() {
            this.searchInput = ""
            this.searchResults = []
            this.$refs.businessSearchInput?.focus()
        },
    },
}
